/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Cookies from 'js-cookie';
import UserHeader from './Parts/Header/Header-User';
import GuestHeader from './Parts/Header/Header-Guest';
import Sidebar from './Parts/Sidebar';
import Footer from './Parts/Footer';
import PrivacyPolicy from './Parts/Sidebar/PrivacyPolicy';
import socket from '../../Socket';
import { Event, decode, encode, wait, isMobile } from '../../Helper';
import WalletAlert from '../Components/User/Wallet/Alert';
import C from '../../Constant';
import Login from './Auth/Login';
import storage from '../../Storage';
import Engine from '../Games/Crash/Engine';
import Canvas from '../Games/Crash/Graphic';
import CanvasSpin from '../Games/Crash/Spin/index';
import Mobi from '../Games/Crash/Graphic/Mobi';
import Bet from '../Games/Crash/Bet';
import Bet1 from '../Games/Crash/Bet1';
import Queue from '../Games/Crash/Queue';
import Queue2 from '../Games/Crash/Queue2';
import QueueSpin from '../Games/Crash/QueueSpin';
import Players from '../Games/Crash/Players';
import Players_spin from '../Games/Crash/Players';
import Menus from '../Games/Crash/includes/Menus';
import Affiliate from '../Pages/Affiliate';
import Carousel from './Parts/Carousel';
import HistoryList from '../Games/Crash/includes/HistoryList';

class Index extends React.Component {
  _Mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
      isLogged: false,
      bid: '',
      token: false,
      header: <GuestHeader t={this.props.t} location={this.props.location} />,
      auth: false,
      code: '',
      betAmounts: [0, 0, 0, 0],
      placedBets: [],
      activeTab: 'crash',
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    wait(500).then(() => {
      this._Mounted = true;
    });
  }

  componentDidMount() {
    // Check for refresh flag
    const shouldRefresh = localStorage.getItem('shouldRefresh');
    if (shouldRefresh === 'true') {
      localStorage.removeItem('shouldRefresh'); // Clear flag immediately
      wait(500).then(() => {
        window.location.reload(); // Trigger single refresh
      });
      return;
    }

    socket.on(C.ONLINE, (data) => this.loginUser(decode(data)));

    // Re-authenticate on page refresh using stored session token
    const storedToken = storage.getKey('token');
    if (storedToken) {
      wait(500).then(() => {
        socket.emit(C.ONLINE, encode({
          jwt_token: storage.getKey('jwt_token'),
          user_token: storage.getKey('user_token'),
          security_key: storage.getKey('security_key'),
          secret_user: storage.getKey('secret_user'),
          secret_realtime: storage.getKey('secret_realtime'),
          client_system: storage.getKey('client_system'),
          token_key: storage.getKey('token_key'),
          secret_token: storage.getKey('secret_token'),
          token: storedToken,
        }));
      });
    }

    wait(600).then(() => {
      this.handleResize();
    });
    window.addEventListener('resize', this.handleResize);

    // Initialize Crash game after session validation
    wait(1000).then(() => {
      if (this._Mounted && storage.getKey('token')) {
        Engine.getStatus();
      }
    });
  }

  componentWillUnmount() {
    socket.off(C.ONLINE);
    window.removeEventListener('resize', this.handleResize);
    localStorage.removeItem('shouldRefresh');
  }

  activeAuth = (status) => {
    this.setState({ auth: status });
  };

  loginUser = (data) => {
    wait(500).then(() => {
      if (data.status === true) {
        this.setState({
          header: <UserHeader t={this.props.t} location={this.props.location} />,
          isLogged: true,
          token: storage.getKey('token'),
          code: data.referral_code,
        });
        Cookies.set('uid', data.id, { expires: 14, path: '/' });
        Cookies.set('auth', true, { expires: 14, path: '/' });
        storage.setKey('name', data.name);
        storage.setKey('email', data.email);
        storage.setKey('credit', data.credit);
        storage.setKey('avatar', data.avatar);
        storage.setKey('friends', data.friends);
        storage.setKey('room', data.room);
        storage.setKey('token', storage.getKey('token'));
      } else {
        wait(7000).then(() => {
          Cookies.remove('session', { path: '/' });
          Cookies.remove('auth', { path: '/' });
          storage.clear();
          this.setState({ auth: true, isLogged: false, token: false });
        });
      }
    });
  };

  getWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
  }

  handleResize() {
    if (this.getWidth() < 1540) {
      this.setState({ col: 'col-xl-12' });
      Event.emit('hide_games');
    } else {
      this.setState({ col: 'col-xl-9' });
      Event.emit('show_min_games');
    }

    if (isMobile()) {
      this.setState({ mobile: true, padding: 'p-0', ovh: 'ovh' });
    } else {
      this.setState({ mobile: false });
    }
  }

  updateBetAmount = (index, amount) => {
    this.setState((prevState) => {
      const updatedBetAmounts = [...prevState.betAmounts];
      updatedBetAmounts[index] = parseFloat(amount);
      return { betAmounts: updatedBetAmounts };
    });
  };

  calculateTotalBetAmount = () => {
    return this.state.betAmounts.reduce((total, amount) => total + amount, 0);
  };

  handlePlaceBet = (index, amount) => {
    this.setState((prevState) => {
      const updatedPlacedBets = [...prevState.placedBets];
      updatedPlacedBets[index] = parseFloat(amount);
      return { placedBets: updatedPlacedBets };
    });
  };

  calculateTotalPlacedBetAmount = () => {
    return this.state.placedBets.reduce((total, amount) => total + (amount || 0), 0);
  };

  switchTab = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  setActiveTab = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  render() {
    let { header, auth, mobile, activeTab } = this.state;
    let { content } = this.props;
    let wallet;

    try {
      wallet = this.props.get_wallet.show;
    } catch (e) { }

    const { t } = this.props;
    const totalPlacedBetAmount = this.calculateTotalPlacedBetAmount();

    return (
      <>
        {header}
        {auth && <Login justModal={true} t={t} />}
        <div className="page-wrapper">
          <div className="page-content container-fluid pb-3" id={'page-content'}>
            <div className="content-section">
              <div className="game-content">
                <div className="row m-0">
                  <div className="col-md-2 p-1 hide-mobile">
                    <div className="clear-bg">
                      <div className="m-0 p-0">
                        <Queue t={t} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 px-1">
                    <div className="row">
                      <div className="col-md-12 px-2">
                        <div className="mt-1 p-0">
                          <Canvas mobile={mobile} />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 col-12 pl-0 pr-0">
                        <div className="d-bets ml-2 mr-1 my-2 pr-0">
                          <Bet
                            mobile={mobile}
                            token={this.state.token}
                            isLogged={this.state.isLogged}
                            bid="0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 p-1">
                    <div className="clear-bg">
                      <div className="m-0 p-0">
                        <Queue2 t={t} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-section pb-2">
              <div className="row text-lightt">
                <div className="col-md-3" style={{ marginBottom: '4px' }}>
                  <div className="footer-card text-left foot-line">
                    <h3>Support</h3>
                    <div>
                      <a href="https://wa.me/254781589968" target="_blank">
                        <i className={'mdi mdi-whatsapp'} style={{ color: '#34B7F1' }}></i>
                        0781 589 968
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-3" style={{ marginBottom: '4px' }}>
                  <div className="footer-card text-left foot-line">
                    <h3>Licence</h3>
                    <ul>
                      <li>BCLB No: 0000756</li>
                      <li><a href="#"></a></li>
                      <li></li>
                      <li></li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3" style={{ marginBottom: '4px' }}>
                  <div className="footer-card text-left foot-line">
                    <h3>Quick Links</h3>
                    <ul>
                      <li><Menus /></li>
                      <li></li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3" style={{ marginBottom: '4px' }}>
                  <div className="footer-card text-left foot-line">
                    <h3>Social Media</h3>
                    <ul className="socials nav">
                      <li className="nav-item"><a href="#"><i className="mdi mdi-facebook fb"></i> Facebook</a></li>
                      <li className="nav-item"><a href="#"><i className="mdi mdi-twitter twta"></i> Twitter</a></li>
                      <li className="nav-item"><a href="#"><i className="mdi mdi-instagram insta"></i> Instagram</a></li>
                      <li className="nav-item"><a href="#"><i className="mdi mdi-instagram insta"></i> Tiktok</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row text-lightt">
                <div className="container-fluid">
                  <p className="text-center">&copy; 2025 Million Bets | All Rights Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Index.propTypes = {
  get_wallet: PropTypes.shape({
    show: PropTypes.bool,
  }),
  t: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  get_wallet: state.items.get_wallet,
});

export default connect(mapStateToProps, null)(Index);